import React, { useEffect } from "react";
import './aboutme.css'
import picture from "../../images/aboutmepic.jpg"
import { NavLink } from "react-router-dom";
import TypeWriterEffect from 'react-typewriter-effect';

export default function Aboutme(){
    useEffect(()=>{
        window.scrollTo({top:0, left:0, behavior:'smooth'})
    })

    return(
        <div className="aboutme_container">
            <div className="aboutme_Wrapper">
                <h1 className="aboutme_header aboutme_header_main big_screen_hide">
                    <TypeWriterEffect
                        textStyle={{ 
                            fontSize: '1.5rem',
                            color: 'green'
                        }}
                        cursorColor="green"
                        startDelay={100}
                        text="About Me,"
                        typeSpeed={100}
                        hideCursorAfterText={true}
                    />
                    
                </h1>
                <p className="aboutme_header aboutme_header_desc big_screen_hide">
                        <TypeWriterEffect
                            textStyle={{ 
                                fontSize: '1rem',
                                fontWeight:'500'
                            }}
                            cursorColor="white"
                            startDelay={1000}
                            text="Let me Introduce Myself"
                            typeSpeed={100}
                            hideCursorAfterText={true}
                        />
                </p>
                <img className="aboutme_image" alt="/" src={picture}></img>

                <div className="aboutme_Wrapper_details">
                    <h1 className="aboutme_header aboutme_header_main small_screen_hide">
                        <TypeWriterEffect
                            textStyle={{ 
                                fontSize: '1.5rem',
                                color: 'green'
                            }}
                            cursorColor="green"
                            startDelay={100}
                            text="About Me,"
                            typeSpeed={100}
                            hideCursorAfterText={true}
                        />
                        
                    </h1>
                    <p className="aboutme_header aboutme_header_desc small_screen_hide">
                        <TypeWriterEffect
                            textStyle={{ 
                                fontSize: '1rem',
                                fontWeight:'500'
                            }}
                            cursorColor="white"
                            startDelay={1000}
                            text="Let me Introduce Myself"
                            typeSpeed={100}
                            hideCursorAfterText={true}
                        />
                        
                    </p>
                    <p className="about_me_text">
                        My name is Melvin Kalidozo, i am a malawian born in blantyre.
                        When i was young i always wanted to be a pilot, funny how things turned out, now i am a proffessional computer scientist and an Education specialist. 
                        Dont get me wrong though, i did not get into this position by accident, but rather my passion for being a pilot changed over time. 
                        I was lucky at home as i was introduced to computers at a very young age, one of my elder brothers owned one in the early 2000. 
                        By that time, in my mind computers where all about video games, i recall spending all of my time on a computer playing old tittles like roadrush, GTA2 and Rollcage, i remember it like it is yesterday. 
                        As time passed a desktop computer was purchased for me at home, it was a pentium 3, 128mb RAM and 60GB internal storage, somewhere around the year 2016. 
                        This is the time i realised that computers where not only about video games but also internet surfing, drawing images(using the paint app) and processing of media files,
                        my passion for computers then grew rapid than ever. 
                        Later when i was in form 3 i decided to pursue a computer studies subject, learning this subject made me aware of the existance of computer programming. 
                        I remember when i wrote my MSCE exams thinking there was nothing else better i can pursue other than a computer related program.
                        From there my Education journey began. Check my CV or go to the skills page for more about my journey.
                    </p>

                    <div className="aboutme_Wrapper_more">
                        <div className="aboutme_more experience">
                            <p className="aboutme_more_count">2</p>
                            <p className="aboutme_more_desc">Months<br></br>experience</p>
                        </div>

                        <div className="aboutme_more experience">
                            <p className="aboutme_more_count">3+</p>
                            <p className="aboutme_more_desc">Projects<br></br>completed</p>
                        </div>

                        <div className="aboutme_more experience">
                            <p className="aboutme_more_count">1</p>
                            <p className="aboutme_more_desc">Company<br></br>worked</p>
                        </div>
                    </div>
                    <div className="about_me_btn_wrapper">
                        <a className="cv_btn greenbtn" href="https://drive.google.com/file/d/1IFz6WeSU5UnaUuDMhCdCGhbN3Ya4zzws/view?usp=sharing">Download CV</a>
                        <NavLink to="/skills" className="skills_btn greenbtn">My Skills</NavLink>
                    </div>
                    
                </div>
                
            </div>  
        </div>
    )
}
    
